import {
  makeEnvironmentProviders,
  type EnvironmentProviders,
} from '@angular/core';

import {
  LAYOUTS_CONFIG,
  layoutsConfig,
  type ILayouts,
} from './providers/layouts-config';

export function provideLayoutsConfig(
  config: ILayouts = layoutsConfig,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: LAYOUTS_CONFIG,
      useValue: config,
    },
  ]);
}
